/** 手机触控：独立操作按钮使用至少44px点击区域；桌面保持原紧凑布局，业务权限、提交与跳转逻辑不变。 */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageSquare, ArrowUpRight, ArrowDownLeft, Image as ImageIcon, AlertCircle } from "lucide-react";
import { fmtTime } from "./AgentCallsTable";

/* 坐席短信记录（外发 + 所属客户回信） */
export function AgentSmsList({ sms, zh, logSince }) {
  const navigate = useNavigate();
  const [dir, setDir] = useState("all");
  const list = sms.filter((s) => dir === "all" || s.direction === dir);
  return (
    <div data-testid="agent-sms-list" data-count={list.length}>
      <div className="flex items-center gap-2 px-3 pt-3 flex-wrap">
        <div className="inline-flex bg-slate-100 rounded-lg p-0.5">
          {[["all", zh ? "全部" : "All"], ["out", zh ? "外发" : "Sent"], ["in", zh ? "客户回信" : "Received"]].map(([k, l]) => (
            <button key={k} data-testid={`agent-sms-filter-${k}`} onClick={() => setDir(k)} className={"min-h-11 min-w-11 md:min-h-0 md:min-w-0 " + (`px-2.5 py-1 text-xs font-medium rounded-md ${dir === k ? "bg-white text-red-600 shadow-sm" : "text-slate-500"}`)}>{l}</button>
          ))}
        </div>
        <span className="text-[11px] text-slate-400">{zh ? "外发短信自 " : "Full SMS text logged since "}{logSince ? fmtTime(logSince) : (zh ? "即日起" : "today")}{zh ? " 起完整留存全文；更早记录仅有收件号与前 60 字（审计日志）" : "; older rows show recipient + first 60 chars (audit log)"}</span>
      </div>
      {list.length === 0 ? (
        <p className="text-sm text-slate-400 text-center py-10" data-testid="agent-sms-empty">{zh ? "该时间范围内无短信记录" : "No SMS in this range"}</p>
      ) : (
        <div className="divide-y divide-slate-50 mt-2">
          {list.map((s) => (
            <div key={`${s.source}-${s.id}`} data-testid={`agent-sms-${s.id}`} data-direction={s.direction} className="flex-wrap md:flex-nowrap flex items-start gap-3 px-3 py-2.5">
              <div className={`mt-0.5 h-7 w-7 rounded-full flex items-center justify-center shrink-0 ${s.direction === "in" ? "bg-sky-50 text-sky-600" : "bg-emerald-50 text-emerald-600"}`}>
                {s.direction === "in" ? <ArrowDownLeft className="h-4 w-4" /> : <ArrowUpRight className="h-4 w-4" />}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap text-xs">
                  <span className="font-medium text-slate-700">{s.direction === "in" ? (zh ? "客户回信" : "Received") : (zh ? "外发" : "Sent")}</span>
                  {s.leadId ? <button onClick={() => navigate(`/crm/leads/${s.leadId}`)} className="min-h-11 min-w-11 md:min-h-0 md:min-w-0 text-amber-700 hover:underline">{s.name || s.number}</button> : <span className="text-slate-600">{s.name || ""}</span>}
                  <span className="font-mono text-slate-400">{s.number}</span>
                  <span className="text-slate-400">{fmtTime(s.at)}</span>
                  {s.media > 0 && <span className="inline-flex items-center gap-0.5 text-slate-400"><ImageIcon className="h-3 w-3" />{s.media}</span>}
                  {s.ok === false && <span className="inline-flex items-center gap-0.5 text-red-600" data-testid={`agent-sms-failed-${s.id}`}><AlertCircle className="h-3 w-3" />{zh ? "发送失败" : "failed"}</span>}
                  {s.source === "audit" && <span className="text-[10px] text-slate-400 border border-slate-200 rounded px-1">{zh ? "审计摘要" : "audit"}</span>}
                </div>
                <p className="text-sm text-slate-800 mt-0.5 whitespace-pre-wrap break-words">{s.body || <span className="text-slate-300">{zh ? "（无正文）" : "(empty)"}</span>}</p>
              </div>
              <MessageSquare className="h-4 w-4 text-slate-200 shrink-0 mt-1" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
